import { render, staticRenderFns } from "./key-visual.vue?vue&type=template&id=06b9f11a&scoped=true"
import script from "./key-visual.vue?vue&type=script&lang=js"
export * from "./key-visual.vue?vue&type=script&lang=js"
import style0 from "./key-visual.vue?vue&type=style&index=0&id=06b9f11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9f11a",
  null
  
)

export default component.exports